import React from 'react';
import { Tag } from 'antd';

const labels: { [key: string]: string } = {
    OVERDUE: '已逾期',
    TODAY: '今日到期',
    CUSTOMER_WAITING: '客户等待',
    THREE_DAYS: '三天内',
    SEVEN_DAYS: '七天内',
    NO_DATE: '缺少日期',
    HIGH: '高',
    MEDIUM: '中',
    NORMAL: '普通',
    READY: '待开始',
    IN_PROGRESS: '进行中',
    WAITING: '等待中',
    COMPLETED: '已完成',
    CANCELLED: '已取消',
    UNASSIGNED: '待分配',
    NEW: '待分诊',
    PENDING_ADMIN: '待分诊',
    PROCESSING: '处理中',
    CLOSED: '已完成',
    TRIAGED: '已分诊',
    ACTIVE: '有效',
    MERGED: '已合并',
    DEMAND_CONFIRMED: '需求已确认',
    SOLUTION_DISCUSSION: '方案沟通中',
    SOLUTION_APPROVED: '方案通过',
    SOLUTION_REJECTED: '方案否决',
    DEMAND_CANCELLED: '需求取消',
    COMMERCIAL_COMPLETED: '商务完成',
    PENDING: '待启动',
    RECEIVED: '已接收',
    PREPARING: '准备中',
    DELIVERING: '交付中',
    PAUSED: '已暂停',
    NOT_STARTED: '未开始',
    NOT_APPLICABLE: '不适用',
    BLOCKED: '受阻',
    ARCHIVED: '已归档',
    DRAFT: '草稿',
    PUBLISHED: '已发布',
    INACTIVE: '未启用',
    DISABLED: '已停用',
    WARMING: '预热中',
    AUTH_ERROR: '认证失败',
    CURSOR_INVALID: '同步游标失效',
    PRECHECKED: '预检通过',
    CONFIRMED: '已确认',
    SCHEDULED: '已排期',
    RUNNING: '发送中',
    RECONCILING: '对账中',
    PARTIAL_FAILED: '部分失败',
    FROZEN: '已冻结',
    VALIDATING: '校验中',
    UPLOADED: '已上传',
    PARSED: '解析完成',
    QUEUED: '排队中',
    PARSING: '解析中',
    MATCHING: '匹配中',
    CONFIRMING: '确认中',
    COMMITTED: '已导入',
    PARTIAL: '部分完成',
    FAILED: '失败',
    ELIGIBLE: '可发送',
    EXCLUDED: '已排除',
    REVIEW: '待复核',
    LEASED: '已领取',
    SUBMITTING: '提交中',
    SUBMITTED: '已提交',
    DEFERRED: '延迟投递',
    UNKNOWN: '结果未知',
    FAILED_RETRYABLE: '等待重试',
    FAILED_FINAL: '最终失败',
    SKIPPED: '已跳过',
    DELIVERED: '已送达',
    SOFT_BOUNCE: '软退信',
    HARD_BOUNCE: '硬退信',
    HUMAN_REPLIED: '人工回复',
    AUTO_REPLIED: '自动回复',
    NONE: '未回复',
    AMBIGUOUS: '待确认',
    UNMATCHED: '未匹配',
    MATCHED: '已匹配',
    INVALID_EMAIL: '邮箱非法',
    MULTIPLE_MATCHES: '多匹配',
    DUPLICATE_IN_FILE: '文件内重复',
    BLOCKED_BY_POLICY: '策略阻断',
    STALE_CONTACT: '联系人失效',
    RETRY: '等待重试',
    DEAD: '处理终止',
    IGNORED: '已忽略',
    HUMAN_REPLY: '人工回复',
    AUTO_REPLY: '自动回复',
    BOUNCE: '退信',
    UNCLASSIFIED: '待分类',
    OTHER: '其他',
    PROVIDER_API: '服务商 API',
    IMAP: 'IMAP',
    PASS: '通过',
    PASS_AUTO: '自动检查通过',
    FAIL: '未通过',
    WARN: '提醒',
    SCANNING: '检查中',
    NOT_TESTED: '未测试',
    PASSED: '已通过',
    LEGACY_ACCEPTED: '历史通过',
    STARTED: '已开始',
    ACCEPTED: '已受理',
    RETRYABLE_FAILURE: '可重试失败',
    FINAL_FAILURE: '最终失败',
};

const colors: { [key: string]: string } = {
    OVERDUE: 'red',
    TODAY: 'orange',
    CUSTOMER_WAITING: 'gold',
    HIGH: 'red',
    MEDIUM: 'orange',
    COMPLETED: 'green',
    COMMERCIAL_COMPLETED: 'green',
    ACTIVE: 'green',
    PASS: 'green',
    PASS_AUTO: 'green',
    PASSED: 'green',
    LEGACY_ACCEPTED: 'cyan',
    DELIVERING: 'blue',
    IN_PROGRESS: 'blue',
    SOLUTION_APPROVED: 'cyan',
    PAUSED: 'gold',
    CANCELLED: 'default',
    SOLUTION_REJECTED: 'volcano',
    DEMAND_CANCELLED: 'default',
    BLOCKED: 'red',
    FAIL: 'red',
    AUTH_ERROR: 'red',
    CURSOR_INVALID: 'red',
    PRECHECKED: 'cyan',
    CONFIRMED: 'blue',
    SCHEDULED: 'geekblue',
    RUNNING: 'blue',
    FROZEN: 'purple',
    ELIGIBLE: 'green',
    EXCLUDED: 'default',
    REVIEW: 'orange',
    SUBMITTED: 'blue',
    DELIVERED: 'green',
    HUMAN_REPLIED: 'green',
    AUTO_REPLIED: 'gold',
    HUMAN_REPLY: 'green',
    AUTO_REPLY: 'gold',
    FAILED: 'red',
    FAILED_FINAL: 'red',
    FAILED_RETRYABLE: 'orange',
    UNKNOWN: 'orange',
    SOFT_BOUNCE: 'orange',
    HARD_BOUNCE: 'red',
    AMBIGUOUS: 'orange',
    UNMATCHED: 'default',
    MATCHED: 'green',
    INVALID_EMAIL: 'red',
    MULTIPLE_MATCHES: 'orange',
    DUPLICATE_IN_FILE: 'gold',
    BLOCKED_BY_POLICY: 'red',
    DEAD: 'red',
};

const StatusTag = ({ value }: { value?: string }) => {
    if (!value) return <span className="v2-muted">—</span>;
    return <Tag color={colors[value] || 'default'}>{labels[value] || value}</Tag>;
};

export const statusLabel = (value?: string) => (value ? labels[value] || value : '—');
export default StatusTag;
